import { createReducer, on } from '@ngrx/store';

import { RegData } from '../core/dtos/reg-data';
import { clearRegData, setProofOfIdentity, setRegTestSession, setTestPurposeLookup, setTestPurposeOption, setScoreReport, setTestTypeId, setRegId } from './reg-data.actions';

export const initialState: RegData = {
  version: 1.00,
  regId: null,
  selectedTestPurposeOption: null,
  testSession: null,
  proofOfIdentity: null,
  scoreReport: null,
  lookup: {
    testPurposes: [],
    institutions: [],
    subscribedInstitutions: null,
  },
};

export const regDataReducer = createReducer(
  initialState,

  on(clearRegData, () => initialState),

  on(setTestPurposeOption, (state, { testPurposeOption }) => ({ ...state, selectedTestPurposeOption: testPurposeOption })),

  on(setRegTestSession, (state, { testSession }) => ({ ...state, testSession })),

  on(setTestTypeId, (state, { testTypeId }) => ({ ...state, testSession: { ...state.testSession, testTypeId } })),

  on(setRegId, (state, { regId }) => ({ ...state, regId })),

  on(setProofOfIdentity, (state, { proofOfIdentity }) => ({ ...state, proofOfIdentity })),

  on(setScoreReport, (state, { scoreReport }) => ({ ...state, scoreReport })),

  on(setTestPurposeLookup, (state, { testPurposes, institutions, subscribedInstitutions }) => ({ ...state, lookup: { ...state.lookup, testPurposes, institutions, subscribedInstitutions } })),

);
